export class RelColaboradoresFactory {
  constructor(instance) {
    this.instance = instance;
  }

  getServicos(filter) {
    return this.instance.get('/v1/relatorios/servicos', {
      params: filter || null,
    });
  }

  getResumoColheita(filter) {
    return this.instance.get('/v1/relatorios/servicos/colheita', {
      params: filter || null,
    });
  }

  exportarResumoColheitaXlsx(filter) {
    return this.instance.get('/v1/relatorios/servicos/colheita/exportar-xlsx', {
      params: filter || null,
      responseType: 'blob',
    });
  }

  getDiarioProducao(filter) {
    return this.instance.get('/v1/relatorios/servicos/diario-producao', {
      params: filter || null,
    });
  }
}

export default RelColaboradoresFactory;
